import React from "react";
import * as MS from "../../styles/ModelStyled";
import { useDispatch } from "react-redux";
import { setIsModal } from "../../store/action";
import redCross from "../../assets/images/greyCross.png";

const ModalPolicy = ({
  component,
  isOpen,
  isClose,
  backColor,
  maxWidth,
  title,
  theme,
  minHeight,
}) => {
  const dispatch = useDispatch();
  return isOpen ? (
    <MS.ModalContainer>
      <MS.InnerBoxPolicy
        maxWidth={maxWidth}
        backColor={backColor}
        themeColor={theme}
        minHeight={minHeight}
      >
        {" "}
        {isClose ? (
          <MS.CrossRow
            themeColor={theme}
            title={title ? true : false}
            onClick={() => {
              isClose(false);
              dispatch(setIsModal(false));
            }}
          >
            <p>{title}</p>
            <img className="cross-con" src={redCross} alt="" />
          </MS.CrossRow>
        ) : (
          ""
        )}
        {component}
      </MS.InnerBoxPolicy>
    </MS.ModalContainer>
  ) : (
    ""
  );
};

export default ModalPolicy;
